/**
 * SEO meta for the public, indexable routes (the ones listed in the sitemap).
 *
 * Single source of truth shared by the page components (via useDocumentMeta)
 * and by scripts/generate-route-meta.ts, which bakes these values into static
 * per-route HTML files at build time so crawlers that don't execute
 * JavaScript still see unique titles, descriptions, and canonicals.
 */

export interface RouteMeta {
  /** Page title - useDocumentMeta appends " | Savin Hood" */
  title: string;
  /** Meta description for SEO */
  description: string;
  /** Canonical URL for SEO - prevents duplicate content issues */
  canonical: string;
}

export const INDEXABLE_ROUTE_META: Record<string, RouteMeta> = {
  '/calculator': {
    title: 'UK Salary Tax Calculator 2026/27 | Escape the £100k Trap',
    description:
      'Calculate UK take-home pay with dividend income, pension strategies & childcare impact. See exactly how to escape the 60% tax trap with personalised optimization strategies.',
    canonical: 'https://app.savinhood.com/calculator',
  },
  '/contractor': {
    title: 'UK Contractor Tax Calculator 2026/27 | Salary vs Dividends',
    description:
      'Calculate your limited company take-home pay. Compare salary vs dividend splits, optimize Corporation Tax, and see the best director salary for 2026/27. IR35 friendly.',
    canonical: 'https://app.savinhood.com/contractor',
  },
  '/pricing': {
    title: 'Pricing',
    description:
      'Subscribe to Savin Hood for monthly income tracking and tax optimization.',
    canonical: 'https://app.savinhood.com/pricing',
  },
  '/tax-code': {
    title: 'UK Tax Code Checker',
    description:
      'Check and understand your UK tax code. Enter your tax code to see what it means for your personal allowance and tax situation.',
    canonical: 'https://app.savinhood.com/tax-code',
  },
};
